import { useEffect } from "react";
import { SidebarProvider, useSidebar } from "../../context/SidebarContext";
import { ThemeProvider } from "../../context/ThemeContext";
import { Outlet, useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";
import Backdrop from "./Backdrop";

const LayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ["current-user"] });
  }, [location.pathname, queryClient]);

  const desktopMargin =
    isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]";

  return (
    <div className="h-screen flex overflow-hidden bg-gray-50 relative">
      <AdminSidebar />
      <Backdrop />

      <div
        className={`flex-1 flex flex-col min-w-0 h-full overflow-hidden transition-all duration-300 ease-in-out ml-0 ${desktopMargin}`}
      >
        <AdminHeader />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 mx-auto w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const AdminLayout = () => {
  return (
    <ThemeProvider>
      <SidebarProvider>
        <LayoutContent />
      </SidebarProvider>
    </ThemeProvider>
  );
};

export default AdminLayout;
